import _extends from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
var __jsx = React.createElement;
import DixuContainer from "../../components/DixuContainer/DixuContainer";
import DixuCustomerExperienceCard from "../../components/DixuCustomerExperienceCard/DixuCustomerExperienceCard";
import { DixuCol, DixuRow } from "../../components/DixuGrid/DixuGrid";
import DixuHead from "../../components/DixuHead/DixuHead";
import DixuTitle from "../../components/DixuTitle/DixuTitle";
import { useTranslation } from "../../i18n";
import React from 'react';
const HeroSection = () => {
  const {
    t
  } = useTranslation(['customerexperiences']);
  return /*#__PURE__*/React.createElement(DixuTitle.PageTitle, {
    subtitleContainerProps: {
      maxWidth: 'md'
    },
    subtitle: t('Olemme toimineet menestyksekkäästi jo yli 30 paikkakunnalla ja auttaneet satoja asiakkaita asunnon myynnissä.')
  }, t('Asiakaskokemuksia'));
};
const ExperiencesSection = _ref => {
  let {
    experiences
  } = _ref;
  return /*#__PURE__*/React.createElement(DixuCustomerExperienceCard.Group, {
    type: "adjust",
    wrapperRow: {
      gutter: [40, 40]
    }
  }, experiences?.map(experience => {
    return /*#__PURE__*/React.createElement(DixuCustomerExperienceCard, _extends({
      key: experience.content
    }, experience, {
      type: "glass"
    }));
  }));
};
const DixuCustomerExperiencesScreen = _ref2 => {
  let {
    experiences
  } = _ref2;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DixuHead, {
    title: "Asiakaskokemuksia",
    description: "Lue asiakkaidemme kokemuksia Dixusta. Olemme toimineet menestyksekk\xE4\xE4sti jo yli 30 paikkakunnalla ja auttaneet satoja asiakkaita asunnon myynniss\xE4."
  }), /*#__PURE__*/React.createElement(DixuContainer, null, /*#__PURE__*/React.createElement(DixuRow, {
    gutter: [0, 74]
  }, /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(HeroSection, null)), /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(ExperiencesSection, {
    experiences: experiences
  })))));
};
export default DixuCustomerExperiencesScreen;